import React, { useCallback } from 'react'
import { withRouter } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import { X } from 'react-feather'
import _ from 'lodash'

import { FilterPanelContainer, FilterSection } from './styles'
import { scheduleTypes } from '~/constants/schedules'
import useOutsideClick from '~/hooks/useOutsideClick'
import { Hide, Show } from '~/components/commons'
import Checkbox from '~/components/Checkbox'

function SideMenu({ children, isSideMenu = false, visible = false, onClose }) {
  const containerRef = useOutsideClick(event => {
    if (isSideMenu && visible) {
      event.stopPropagation()
      onClose()
    }
  })

  return (
    <FilterPanelContainer
      className={classnames({
        customizer: isSideMenu,
        open: visible,
      })}
      style={{ width: isSideMenu && 260 }}
      ref={containerRef}
    >
      <Show condition={isSideMenu}>
        <div className="header d-flex justify-content-between px-2 pt-2">
          <div className="close-icon cursor-pointer" onClick={onClose}>
            <X size={24} />
          </div>

          <span className="h4 m-0">
            <FormattedMessage id="Filters" />
          </span>
        </div>
      </Show>

      <PerfectScrollbar
        options={{
          wheelPropagation: true,
        }}
        className="customizer-content"
      >
        {children}
      </PerfectScrollbar>
    </FilterPanelContainer>
  )
}

function SchedulesFilterPanel({
  isVisibleSideMenu,
  setIsVisibleSideMenu,
  isMobileMode,
  queryParams,
  setQueryParams,
}) {
  const allScheduleTypes = Object.keys(scheduleTypes)

  const handleFilterPropertyChange = useCallback(
    (filter, value) => {
      setQueryParams({ ...queryParams, [filter]: value })
    },
    [queryParams, setQueryParams]
  )

  const handleNotificationsChange = key => {
    if (queryParams.scheduleType[0] === 'all') {
      return handleFilterPropertyChange(
        'scheduleType',
        allScheduleTypes.filter(v => v !== key)
      )
    }

    const values = _.castArray(queryParams.scheduleType)
    const index = values?.findIndex(v => v === key)
    if (index !== -1) {
      values.splice(index, 1)
      handleFilterPropertyChange(
        'scheduleType',
        values.length ? values : ['all']
      )
    } else {
      values.push(key)
      handleFilterPropertyChange(
        'scheduleType',
        values.length === allScheduleTypes.length ? ['all'] : values
      )
    }
  }

  return (
    <SideMenu
      isSideMenu={isMobileMode}
      visible={isVisibleSideMenu && isMobileMode}
      onClose={() => setIsVisibleSideMenu(false)}
    >
      <Hide condition={isMobileMode}>
        <FilterSection style={{ borderBottom: 'none' }}>
          <label
            style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#000',
              marginBottom: '20px',
            }}
          >
            <b>
              <FormattedMessage id="Types" />
            </b>
          </label>
          {Object.entries(scheduleTypes).map(([key, value]) => (
            <Checkbox
              color="primary"
              className="mb-50"
              label={value}
              size="md"
              key={key}
              checked={
                queryParams.scheduleType.includes(key) ||
                queryParams.scheduleType[0] === 'all'
              }
              onChange={() => handleNotificationsChange(key)}
            />
          ))}
        </FilterSection>
      </Hide>
    </SideMenu>
  )
}

export default withRouter(SchedulesFilterPanel)
